import { render, staticRenderFns } from "./BowtieSection.vue?vue&type=template&id=a0be9ef4&scoped=true&"
import script from "./BowtieSection.vue?vue&type=script&lang=js&"
export * from "./BowtieSection.vue?vue&type=script&lang=js&"
import style0 from "./BowtieSection.vue?vue&type=style&index=0&id=a0be9ef4&lang=scss&scoped=true&"
import style1 from "./BowtieSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0be9ef4",
  null
  
)

export default component.exports